var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconAcceleration = function SvgIconAcceleration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-Acceleration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.598v-.025a2.758 2.758 0 0 0-.919-2.028l-6.314-5.638a1.875 1.875 0 0 0-2.498 2.798l3.38 3.018H25.43c-.909-6.176-6.234-10.932-12.646-10.932C5.734 16.791 0 22.536 0 29.598s5.734 12.807 12.783 12.807c6.412 0 11.737-4.756 12.645-10.932H57.65l-3.381 3.02a1.874 1.874 0 1 0 2.498 2.796l6.314-5.638A2.757 2.757 0 0 0 64 29.623v-.024Zm-51.217 9.057c-4.981 0-9.033-4.063-9.033-9.057 0-4.994 4.052-9.057 9.033-9.057 4.34 0 7.974 3.085 8.838 7.182H15.6a1.875 1.875 0 1 0 0 3.75h6.02c-.864 4.098-4.499 7.182-8.838 7.182Z",
    fill: "#202931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.617 14.499c0 1.036.84 1.875 1.875 1.875H59.89a1.875 1.875 0 1 0 0-3.75H39.492c-1.035 0-1.875.84-1.875 1.875Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.92 10.125h15.815a1.875 1.875 0 0 0 0-3.75H25.92a1.875 1.875 0 0 0 0 3.75ZM47.95 10.125h2.925a1.875 1.875 0 1 0 0-3.75H47.95a1.875 1.875 0 1 0 0 3.75Z",
    fill: "#202931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.79 16.248a1.875 1.875 0 0 0 0 3.75h2.924a1.875 1.875 0 1 0 0-3.75H26.79Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.219 38.745a1.875 1.875 0 1 0 0-3.75h-2.925a1.875 1.875 0 1 0 0 3.75h2.925Z",
    fill: "#202931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.219 50.25H11.862a1.875 1.875 0 0 0 0 3.75h20.357a1.875 1.875 0 1 0 0-3.75ZM45.831 44.002H30.017a1.875 1.875 0 0 0 0 3.75h15.814a1.875 1.875 0 1 0 0-3.75Z",
    fill: "#14D64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.802 47.752a1.875 1.875 0 1 0 0-3.75h-2.925a1.875 1.875 0 0 0 0 3.75h2.925Z",
    fill: "#202931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.962 53.875h-2.924a1.875 1.875 0 1 0 0 3.75h2.924a1.875 1.875 0 0 0 0-3.75Z",
    fill: "#14D64D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-Acceleration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};

export default SvgIconAcceleration;